import { createEffectHook } from '../factories/createEffectHook'
import { TypedEvent } from '../models/TypedEvent'

import type { TypedNode } from '../models/TypedNode'
import type { SnapshotRelation } from '../types'

export interface SnapshotEventConstructor {
  new (...args: any[]): TypedEvent<TypedNode, SnapshotRelation>
}

/**
 * TypedNode 从快照恢复完成时触发
 */
export class FromSnapshotEvent extends TypedEvent<TypedNode, SnapshotRelation> {
  type = 'onFromSnapshot' as const
}

export const { onFromSnapshot, onFromSnapshotCapture } =
  createEffectHook(FromSnapshotEvent)

declare global {
  export interface RehajeTypedEvents {
    onFromSnapshot: FromSnapshotEvent
  }
}
